'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ms_MY = require('../vc-pagination/locale/ms_MY');

var _ms_MY2 = _interopRequireDefault(_ms_MY);

var _ms_MY3 = require('../date-picker/locale/ms_MY');

var _ms_MY4 = _interopRequireDefault(_ms_MY3);

var _ms_MY5 = require('../time-picker/locale/ms_MY');

var _ms_MY6 = _interopRequireDefault(_ms_MY5);

var _ms_MY7 = require('../calendar/locale/ms_MY');

var _ms_MY8 = _interopRequireDefault(_ms_MY7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  locale: 'ms-my',
  Pagination: _ms_MY2['default'],
  DatePicker: _ms_MY4['default'],
  TimePicker: _ms_MY6['default'],
  Calendar: _ms_MY8['default'],
  global: {
    placeholder: 'Sila pilih'
  },
  PageHeader: {
    back: 'Kembali'
  },
  Text: {
    edit: 'Sunting',
    copy: 'Salin',
    copied: 'Berjaya menyalin',
    expand: 'Kembang'
  },
  Empty: {
    description: 'Tiada data'
  },
  Table: {
    filterTitle: 'Cari dengan tajuk',
    filterConfirm: 'Ok',
    filterReset: 'Menetapkan semula',
    emptyText: 'Tiada data',
    selectAll: 'Pilih semua',
    selectInvert: 'Terbalikkan'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Batal',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Batal'
  },
  Transfer: {
    notFoundContent: 'Tidak dijumpai',
    searchPlaceholder: 'Carian di sini',
    itemUnit: 'item',
    itemsUnit: 'item'
  },
  Icon: {
    icon: 'ikon'
  },
  Select: {
    notFoundContent: 'Tidak Dijumpai'
  },
  Upload: {
    uploading: 'Sedang memuat naik...',
    removeFile: 'Buang fail',
    uploadError: 'Masalah muat naik',
    previewFile: 'Tengok fail',
    downloadFile: 'Muat turun fail'
  }
};